/**
 * NationalId component used to get the user's national ID type and value
 * - used with account creation and can be a hidden input
 */

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import { TextInput, DropdownMenu } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import { getCountryInfo } from './util/localizer';
import _isEmpty from 'lodash/isEmpty';

const STYLES = StyleSheet.create({
	typeWrapper: {
		margin: '10px 0 0',
		position: 'relative',
	},
	errorMessage: {
		transition: 'all 0.25s ease-in-out'
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		appearance: 'none'
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: '50%',
		cursor: 'default',
		pointerEvents: 'none'
	},
	arrowError: {
		marginTop: -17
	},
	errorStyles: {
		height: '100%'
	}
});

class NationalId extends React.Component {
	constructor(props) {
		super(props);
		const nationalIds = !_isEmpty(this.props.nationalIds) ? this.props.nationalIds : getCountryInfo(this.props.country).nationalIds;
		this.state = {
			nationalIdTypeIdx: nationalIds.findIndex(item => item.value === this.props.defaultIdType),
		};
	  }
    static propTypes = {
		country: PropTypes.string,
		labelNationalIdType: PropTypes.string,
		labelNationalIdNumber: PropTypes.string,
		helpText: PropTypes.string,
		showErrorMessages: PropTypes.bool,
		value: PropTypes.string,
		errorMessageType: PropTypes.string,
		errorMessageNumber: PropTypes.string,
		defaultIdType: PropTypes.string,
		nationalIds: PropTypes.array,
		changeEmail: PropTypes.func,
		handleFocus: PropTypes.func,
		handleBlur: PropTypes.func,
		resetNationalId: PropTypes.func,
		validNationalIdType: PropTypes.func,
		validNationalIdNumber: PropTypes.func,
	};

    static defaultProps = {
        showErrorMessages: true,
        handleFocus: () => {},
        handleBlur: () => {},
        resetNationalId: () => {},
        validNationalIdType: () => {},
        validNationalIdNumber: () => {},
    };

    /**
	 * Call parent's handleFocus
	 * @param {String} nationalIdNumber - national ID number
	 */
    handleFocus = (nationalIdNumber) => {
		this.props.handleFocus(nationalIdNumber);
	};

    /**
	 * Call parent's handleBlur
	 * @param {String} nationalIdNumber - national ID number
	 */
    handleBlur = (nationalIdNumber) => {
		this.props.handleBlur(nationalIdNumber);
	};
	getNationalIds = () => {
		const countryInfo = getCountryInfo(this.props.country);
		// Getting natiponal id's from props or from localizer
		return !_isEmpty(this.props.nationalIds) ? this.props.nationalIds : countryInfo.nationalIds;
	}
	getNationalIdOptions = () => {
		const nationalIds = this.getNationalIds();
		return nationalIds.map((item) => {
			return {
				primaryText: item.label,
			}
		})
	}

    /**
	 * handleChangeNationalIdType
	 * @param {Number} index - national ID type index
	 */
    handleChangeNationalIdType = index => {
		this.setState({ nationalIdTypeIdx: index });
		const nationalIds = this.getNationalIds();
		let nationalIdType = nationalIds[index].value;

		if (nationalIdType) {
			this.props.validNationalIdType(nationalIdType);
		} else {
			this.props.resetNationalId();
		}
	};

    /**
	 * Call parent's handleFocus
	 * @param {String} nationalIdNumber - national ID number
	 */
    handleChangeNationalNumber = (nationalIdNumber) => {
		this.setState({ nationalIdNumber });
		if (nationalIdNumber) {
			this.props.validNationalIdNumber(nationalIdNumber);
		} else {
			this.props.resetNationalId();
		}
		return nationalIdNumber;
	};

    render() {
		const countryInfo = getCountryInfo(this.props.country);
		const { value: initialValue, errorMessageType, errorMessageNumber, showErrorMessages } = this.props;

		let typeWrapperClassNames = classNames(css(STYLES.typeWrapper), {
            'vx_has-error-with-message ppvx_field--error': errorMessageType,
        });

		// define the wrapper classNames, which handle showing error messages
		let numberWrapperClassNames = classNames(css(STYLES.typeWrapper), {
            'vx_has-error-with-message ppvx_field--error': errorMessageNumber
        });

		return (
			<div>
				{countryInfo.showNationalId && <div>
					<div className={typeWrapperClassNames}>
						<DropdownMenu type="button" 
							label={this.props.labelNationalIdType || 'ID Type'}
							aria-label={this.props.labelNationalIdType || 'ID Type'}
							errorText={errorMessageType}
							placeholder=""
							id="nationalIdType"
							name="nationalIdType"
							onSelection={this.handleChangeNationalIdType}
							options={this.getNationalIdOptions()}
							selectedItemIndex={this.state.nationalIdTypeIdx}
						/>
					</div>

					<div className={numberWrapperClassNames} style={{ margin: '10px 0 0', position: 'relative' }}>
						<TextInput
							type="text"
							name="nationalIdNumber"
							id="nationalIdNumber"
							className="vx_form-control vx_form-control_complex"
							label={this.props.labelNationalIdNumber}
							placeholder=""
							required={true}
							value={initialValue}
							errorText={showErrorMessages && errorMessageNumber}
							onChange={(event) => this.handleChangeNationalNumber(event.target.value)}
							onFocus={(event) => this.handleFocus(event.target.value)}
							onBlur={(event) => this.handleBlur(event.target.value)}
						/>
					</div>
				</div>
				}
			</div>
		);
	}
}

export default NationalId;
